import Vue from 'vue';

import {
  VBTooltipPlugin,
  VBTogglePlugin,
  BRow,
  BCol,
  BContainer,
  BCard,
  BCardHeader,
  BCardFooter,
  BCardBody,
  BCardText,
  BButton,
  BButtonGroup,
  BCollapse,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormRadio,
  BFormRadioGroup,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormFile,
  BFormDatepicker,
  BFormSelect,
  BFormSelectOption,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupAppend,
  BListGroup,
  BListGroupItem,
  BModal,
  BPagination,
  BTabs,
  BTab,
  BSpinner,
  BBadge,
  BTable,
  BTableSimple,
  BTbody,
  BThead,
  BTfoot,
  BTr,
  BTd,
  BTh,
  BCarousel,
  BCarouselSlide,
  VBToggle
} from 'bootstrap-vue';

Vue.use(VBTooltipPlugin);
Vue.use(VBTogglePlugin);

Vue.component('BRow', BRow);
Vue.component('BCol', BCol);
Vue.component('BContainer', BContainer);
Vue.component('BCard', BCard);
Vue.component('BCardHeader', BCardHeader);
Vue.component('BCardFooter', BCardFooter);
Vue.component('BCardBody', BCardBody);
Vue.component('BCardText', BCardText);
Vue.component('BButton', BButton);
Vue.component('BButtonGroup', BButtonGroup);
Vue.component('BCollapse', BCollapse);
Vue.component('BForm', BForm);
Vue.component('BFormGroup', BFormGroup);
Vue.component('BFormInput', BFormInput);
Vue.component('BFormTextarea', BFormTextarea);
Vue.component('BFormRadio', BFormRadio);
Vue.component('BFormRadioGroup', BFormRadioGroup);
Vue.component('BFormCheckbox', BFormCheckbox);
Vue.component('BFormCheckboxGroup', BFormCheckboxGroup);
Vue.component('BFormFile', BFormFile);
Vue.component('BFormDatepicker', BFormDatepicker);
Vue.component('BFormSelect', BFormSelect);
Vue.component('BFormSelectOption', BFormSelectOption);
Vue.component('BInputGroup', BInputGroup);
Vue.component('BInputGroupPrepend', BInputGroupPrepend);
Vue.component('BInputGroupAppend', BInputGroupAppend);
Vue.component('BListGroup', BListGroup);
Vue.component('BListGroupItem', BListGroupItem);
Vue.component('BModal', BModal);
Vue.component('BPagination', BPagination);
Vue.component('BTabs', BTabs);
Vue.component('BTab', BTab);
Vue.component('BSpinner', BSpinner);
Vue.component('BBadge', BBadge);
Vue.component('BTable', BTable);
Vue.component('BTableSimple', BTableSimple);
Vue.component('BTbody', BTbody);
Vue.component('BThead', BThead);
Vue.component('BTfoot', BTfoot);
Vue.component('BTr', BTr);
Vue.component('BTd', BTd);
Vue.component('BTh', BTh);
Vue.component('BCarousel', BCarousel);
Vue.component('BCarouselSlide', BCarouselSlide);
Vue.component('VBToggle', VBToggle);
